const LOAD_DATA_MASTER_SKILL           = 'LOAD_DATA_MASTER_SKILL'
const LOAD_DATA_MASTER_SKILL_SUCCESS   = 'LOAD_DATA_MASTER_SKILL_SUCCESS'
const LOAD_DATA_MASTER_SKILL_FAILED    = 'LOAD_DATA_MASTER_SKILL_FAILED'
const UNMOUNT_DATA_MASTER_SKILL        = 'UNMOUNT_DATA_MASTER_SKILL'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterSkillReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_SKILL:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_SKILL_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_SKILL_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_SKILL:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterSkillReducer;